import {PromotionTextTypes} from '~/utils/constants';

import instance from './instance';
import {PromotionCategories} from './types';
import {ProfileType} from '../promotions';

export type FetchPromotionCategoriesParams = {
  type: PromotionTextTypes;
  entityType?: ProfileType | null;
  cityIds?: number[];
  url?: string;
  extraCategoryIds?: number[];
};

export const fetchPromotionCategories = ({
  type,
  cityIds,
  url,
  entityType,
  extraCategoryIds,
}: FetchPromotionCategoriesParams) =>
  instance.post<PromotionCategories>(`/frontend/api/v1/category`, {
    type,
    url,
    extraCategoryIds,
    entityType,
    cityIds: cityIds?.map((v: number | string) => {
      if (typeof v === 'string') {
        return parseInt(v, 10);
      }
      return v;
    }),
  });
